import React, { FC } from 'react'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import styled, { StyledProps } from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { IPointsInfo } from '../types'
import { usePointsList } from '../bll/usePointsList'

const Rectangle = styled.div`
  height: 4px;
  background-color: ${sv.color.blue};
  border-radius: 4px;
  margin: 0 8px;
  flex: 1;
`

const Line = styled.div<StyledProps<{ width: string }>>`
  align-items: center;
  display: flex;
  width: ${(props) => props.width};
`

const Item = styled.div`
  align-items: center;
  display: flex;
`

const PointsInfo: FC<IPointsInfo> = (props) => {
  const { title, list } = props

  const items = usePointsList(list)

  if (!list || items.length < 2) return null

  return (
    <div>
      <Heading h3={title} spacing='small' />

      <div>
        {items.map((item, index, array) => {
          return (
            <div key={index}>
              <Item>
                <div
                  style={{
                    minWidth: '40px',
                  }}
                >
                  <Text fontWeight='semibold'>{item.year}</Text>
                </div>

                <div
                  style={{
                    flex: 1,
                  }}
                >
                  <Line width={`${item.value}%`}>
                    <Rectangle />

                    <Text fontWeight='semibold'>{item.point}</Text>
                  </Line>
                </div>
              </Item>

              {array.length - 1 !== index && <Spacing spacing='xsmall' />}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default PointsInfo
